import React, { useState, useEffect, useRef } from 'react'
import Container from '../container/Container'
import { Section, p, FormWrapper } from './AutoFormStyled'
import IncreaseBy from './IncreaseBy'
// import OnLossSection from './OnLossSection'
import Button from 'components/button/Button'
import Input from 'components/input/Input'
import StopOn from './StopOn'
import { ReactComponent as InfiniteSVG } from './svg/infinite.svg'

import StakeOperations from './StakeOperations'
// import SFXS from '../../assets/audios/audios'
import { AutoFormProps } from './interface'

export default function AutoForm({
  stake,
  handleStake,
  autoConfigs,
  handleAutoConfigs,
  handleAbove,
  colors,
  audio,
  handleNotification,
  gameInfo,
  increaseBy,
  stopOn,
  SFXS,
}: AutoFormProps) {
  const {
    numberOfBets: numberOfBetsP,
    onWinIncrease: onWinIncreaseP,
    onWinPercent: onWinPercentP,
    onLossIncrease: onLossIncreaseP,
    onLossPercent: onLossPercentP,
    stopOnProfit: stopOnProfitP,
    stopOnLoss: stopOnLossP,
  } = autoConfigs
  const [numberOfBets, setnumberOfBets] = useState<string>(numberOfBetsP)
  const [onWinIncrease, setonWinIncrease] = useState<boolean>(onWinIncreaseP)
  const [onWinPercent, setonWinPercent] = useState<string>(onWinPercentP)
  const handleOnWin = (onWinIncrease: boolean, onWinPercent: string) => {
    setonWinIncrease(onWinIncrease)
    setonWinPercent(onWinPercent)
  }
  const [onLossIncrease, setonLossIncrease] = useState<boolean>(onLossIncreaseP)
  const [onLossPercent, setonLossPercent] = useState<string>(onLossPercentP)
  const handleOnLoss = (onLossIncrease: boolean, onLossPercent: string) => {
    setonLossIncrease(onLossIncrease)
    setonLossPercent(onLossPercent)
  }

  const [stopOnProfit, setstopOnProfit] = useState<string>(stopOnProfitP)
  const [stopOnLoss, setstopOnLoss] = useState<string>(stopOnLossP)
  const [send, setsend] = useState(false)
  const inputEl = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    if (send) {
      handleAutoConfigs(
        {
          numberOfBets,
          onWinIncrease,
          onWinPercent,
          onLossIncrease,
          onLossPercent,
          stopOnProfit,
          stopOnLoss,
        },
        number,
      )
    }
    return () => {
      setsend(false)
    }
  }, [
    send,
    numberOfBets,
    onWinIncrease,
    onWinPercent,
    onLossIncrease,
    onLossPercent,
    stopOnProfit,
    stopOnLoss,
  ])

  const [number, setnumber] = useState(stake)

  const handleSetStake = (b: boolean) => b && handleStake(number)

  const handleSubmit = (b: boolean) => {
    if (b && number <= gameInfo.maxBet) {
      handleSetStake(b)
      if (inputEl.current) {
        inputEl.current.focus()
      }
      setsend(true)
    }
  }

  return (
    <Container unBlur={false} backgroundColor={colors.primary}>
      <FormWrapper autoComplete='off'>
        <h6>NUMBER OF BETS</h6>
        <Section border data-testid='sectionNOB'>
          <Input
            // number={numberOfBets}
            number={
              numberOfBets !== '0' && numberOfBets !== '' ? numberOfBets : ''
            }
            setnumber={(e: any) => setnumberOfBets(e)}
            setinputStake={(e: any) => setnumberOfBets(e)}
            toFix={0}
            type='onlyNumbers'
            min='0'
            max='10000'
            maxLength={4}
            width='100%'
            height='24px'
            size='12px'
            textcenter='left'
            margin='25px'
            datatestid='numberOfBetsInput'
          />
          {(numberOfBets === '' || numberOfBets === '0') && (
            <InfiniteSVG className='infinite' />
          )}
        </Section>
        {increaseBy && (
          <IncreaseBy
            title='ON WIN'
            increase={onWinIncrease}
            percent={onWinPercent}
            handleOnWin={handleOnWin}
            audio={audio}
            datatestid='increaseByOnWin'
          />
        )}
        {increaseBy && (
          <IncreaseBy
            title='ON LOSS'
            increase={onLossIncrease}
            percent={onLossPercent}
            handleOnWin={handleOnLoss}
            audio={audio}
            datatestid='increaseByOnLoss'
          />
        )}
        {stopOn && (
          <StopOn
            stopOnProfit={stopOnProfit}
            setstopOnProfit={setstopOnProfit}
            stopOnLoss={stopOnLoss}
            setstopOnLoss={setstopOnLoss}
            currency={gameInfo.currency}
          />
        )}
        <StakeOperations
          stake={number}
          setnumber={setnumber}
          audio={audio}
          gameInfo={gameInfo}
          handleNotification={handleNotification}
          colors={colors}
        />
        <Section>
          <Button
            audio={audio}
            func={(b: boolean) => handleSubmit(b)}
            width='100%'
            SFX={SFXS.confirmSFX}
            background={colors.secondary}
            textColor={colors.tertiaryDark}
          >
            start game
          </Button>
        </Section>
        <p
          data-testid='back'
          style={p}
          onClick={() => {
            SFXS.goBackSFX.play()
            return handleAbove(false)
          }}
        >
          BACK
        </p>
        <input
          style={{ width: 0, height: 0, border: 0, pointerEvents: 'none' }}
          ref={inputEl}
        />
      </FormWrapper>
    </Container>
  )
}
